// extracted by mini-css-extract-plugin
export default {"btnClass":"NewAccountConfiguration_btnClass__odFBr"};